import PropTypes from 'prop-types'
import { useState } from 'react'

import { Box, LoadingButton, LoadingPlane } from '@redriverpress/system'

import GenreHeader from './GenreHeader'

import { useMediaGallery } from '../../../contexts'

import useVideoGenres from '../../hooks/useVideoGenres'

import VideoCard from '../VideoCard'
import VideosGrid from '../VideosGrid'
import VideoAccessDialog from '../../../common/components/VideoAccessDialog'

export default function AllVideosGenre({ userLoggedIn, userHasAccess }) {
  const [{ randomVideos }, fetchMedia] = useMediaGallery()
  const { data: videos, currentPage, totalPages } = randomVideos
  const [fetchPending, setFetchPending] = useState(false)
  const [isAccessDialogOpen, setIsAccessDialogOpen] = useState(false)

  const handleFetch = async () => {
    setFetchPending(true)
    await fetchMedia('videos')
    setFetchPending(false)
  }

  const { genres } = useVideoGenres()

  if (genres && videos.length > 0) {
    return (
      <>
        <GenreHeader />
        <VideosGrid>
          {videos.map(video => (
            <VideoCard
              key={video.id}
              video={video}
              isUserAllowed={userLoggedIn && userHasAccess}
              openInfoModal={() => setIsAccessDialogOpen(true)}
            />
          ))}
        </VideosGrid>
        {currentPage !== totalPages && (
          <Box my={4} textAlign='center'>
            <LoadingButton
              onClick={handleFetch}
              disabled={fetchPending}
              loading={fetchPending}
              icon='arrow-down'
            >
              View More
            </LoadingButton>
          </Box>
        )}
        <VideoAccessDialog
          open={isAccessDialogOpen}
          onOpenChange={open => setIsAccessDialogOpen(open)}
          userLoggedIn={userLoggedIn}
        />
      </>
    )
  }
  return (
    <Box display='flex' justifyContent='center'>
      <LoadingPlane />
    </Box>
  )
}

AllVideosGenre.propTypes = {
  userLoggedIn: PropTypes.bool.isRequired,
  userHasAccess: PropTypes.bool.isRequired,
}
